import { render, staticRenderFns } from "./singleActivity.vue?vue&type=template&id=219394bc&scoped=true&"
import script from "./singleActivity.vue?vue&type=script&lang=js&"
export * from "./singleActivity.vue?vue&type=script&lang=js&"
import style0 from "./singleActivity.vue?vue&type=style&index=0&id=219394bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219394bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VRow,VSelect})
